<template>
  <div>
    <div class="content">
      <div class="left">
        <div title="隐患整改详情" class="left-top">
          <!-- 圆环3D图 -->
          <!-- <hidden-danger-handle-ring
            v-if="resData.troubleInfo"
            :echartsData="resData.troubleInfo"
          ></hidden-danger-handle-ring> -->
          <div class="left-top-title">隐患整改详情</div>
          <div>
            <div class="triple">
              <div class="scale">
                <div class="num">{{ resData.troubleInfo.hiddenScale }}%</div>
                <div class="name">整改率</div>
              </div>
              <div class="triple-list">
                <div
                  class="triple-first"
                  @click="checkHiddenDanger(resData.troubleInfo.hiddenTotal, 0)"
                >
                  <div class="triple-num">
                    {{ resData.troubleInfo.hiddenTotal }}
                  </div>
                  <div class="triple-name">隐患总数</div>
                </div>
                <div
                  class="triple-second"
                  @click="checkHiddenDanger(resData.troubleInfo.noHidden, 1)"
                >
                  <div class="triple-num">
                    {{ resData.troubleInfo.noHidden }}
                  </div>
                  <div class="triple-name">未处理隐患总数</div>
                </div>
                <div
                  class="triple-third"
                  @click="checkHiddenDanger(resData.troubleInfo.hiddened, 2)"
                >
                  <div class="triple-num">
                    {{ resData.troubleInfo.hiddened }}
                  </div>
                  <div class="triple-name">已验收隐患总数</div>
                </div>
              </div>
            </div>
          </div>
          <hidden-danger-dialog
            :showCount="showCount"
            :searchParams="searchParams"
          ></hidden-danger-dialog>
        </div>
        <!-- 饼状3D图 -->
        <!-- <hidden-danger-pie
            v-if="resData.dangerDynamicTypes"
            :echartsData="resData.dangerDynamicTypes"
          ></hidden-danger-pie> -->
        <div title="发现隐患分类占比" class="left-center">
          <div class="left-center-title">发现隐患分类占比</div>
          <!-- <unsafe-type-echarts
            class="unsafe-type-chart"
            :echartsData="resData.dangerDynamicTypes"
          ></unsafe-type-echarts> -->
          <hidden-type-hcharts
              style="width:100%"
              :echartsData="resData.dangerDynamicTypes"
            ></hidden-type-hcharts>
        </div>
        <!-- 折线图 -->
        <div title="区域隐患统计" class="left-bottom">
          <div class="left-bottom-title">区域隐患统计</div>
          <hidden-danger-statistic
            v-if="resData.troubleStatistics"
            :echartsData="resData.troubleStatistics"
          >
          </hidden-danger-statistic>
        </div>
      </div>
      <div class="center" style="margin-top:40px">
        <hidden-danger-num
          :num="resData.troubleInfo.noHidden"
          msg="未处理隐患总数"
        ></hidden-danger-num>
        <div class="map">
          <map-content
            :cityArr="cityArr"
            :cityCode="cityCode"
            @refreshData="refreshData"
            :tooltip="tooltip"
            :isbaifen="false"
            :pieces="pieces"
          ></map-content>
        </div>
      </div>
      <school-list
        v-if="this.eduInfo.eduBuresuType != 2"
        :schoolList="schoolList"
        @clickRow="clickRow"
        ref="schoolList"
      ></school-list>
      <school-list-area
        v-else
        :schoolList="schoolList"
        :areaSchoolList="areaSchoolList"
        @clickRow="clickRow"
      ></school-list-area>
    </div>
  </div>
</template>

<script>
import theNowTime from "./components/theNowTime";
import hiddenDangerHandleRing from "./components/hiddenDangerHandleRing";
import hiddenDangerDialog from "./components/hiddenDangerDialog";
import hiddenDangerPie from "./components/hiddenDangerPie";
import hiddenDangerStatistic from "./components/hiddenDangerStatistic";
import hiddenDangerNum from "./components/hiddenDangerNum";
import mapContent from "./components/mapContent";
import schoolList from "./components/schoolList";
import schoolListArea from "./components/schoolListArea";
import unsafeTypeEcharts from "./components/unsafeTypeEcharts";
import hiddenTypeHcharts from "./components/hiddenTypeHcharts";
export default {
  name: "",
  components: {
    theNowTime,
    hiddenDangerHandleRing,
    hiddenDangerDialog,
    hiddenDangerPie,
    hiddenDangerStatistic,
    hiddenDangerNum,
    mapContent,
    schoolList,
    schoolListArea,
    unsafeTypeEcharts,
    hiddenTypeHcharts
  },
  props: {},
  data() {
    return {
      eduInfo: JSON.parse(sessionStorage.getItem("eduInfo")),
      resData: {
        dangerDynamicTypes: [],
        troubleInfo: {
          hiddenTotal: "",
          noHidden: 0
        },
        schoolInfo: {
          schoolNum: "",
          noHidden: "",
          hiddened: ""
        },
        areaScore: {
          scoreRank: []
        }
      },
      schoolList: [],
      areaSchoolList: [], //乡镇中心校学校列表
      msg: "区域内隐患",
      cityArr: [],
      cityCode: "",
      pieces: [
        { gt: 20, label: "危险", color: "#DF5148" },
        { gt: 6, lte: 20, label: "警告", color: "#E9D74C" },
        { lte: 6, label: "安全", color: "#47B85E " }
      ],
      tooltip: [
        {
          title: "未处理隐患数",
          value: "value"
        }
      ],
      showCount: 0, // 值改变，触发查看隐患弹窗
      // 查看隐患时传的参数
      searchParams: {
        eduId: "",
        regionCode: "",
        eduBuresuType: "",
        type: "",
        schoolId: ""
      }
    };
  },
  created() {
    let req = {
      eduId: this.eduInfo.eduId,
      regionCode: parseInt(this.eduInfo.regionCode),
      eduBuresuType: this.eduInfo.eduBuresuType
    };
    this.getEduHiddenDangerStatistics(req);
    if (this.eduInfo.eduBuresuType == 2) {
      // 区县获取中心学校列表
      this.getAreaSchoolList();
    }
  },
  mounted() {},
  computed: {},
  watch: {},
  methods: {
    refreshData(obj) {
      let req = {
        eduId: obj.eduId,
        regionCode: parseInt(obj.regionCode),
        eduBuresuType: obj.eduBuresuType
      };
      this.getEduHiddenDangerStatistics(req);
      if (this.eduInfo.eduBuresuType == 2) {
        // 区县获取中心学校列表
        this.getAreaSchoolList();
      }
      if (this.$refs.schoolList.$refs.rateItem) {
        this.$refs.schoolList.$refs.rateItem.map((item) => {
          return (item.className = "rate-list");
        });
      }
    },
    async getEduHiddenDangerStatistics(req) {
      let res = await this.$Http.getEduHiddenDangerStatistics(req);
      this.cityCode = req.regionCode + "";
      // console.log(res);
      if (res.code == 200) {
        if (res.data) {
          this.resData = res.data;
          this.schoolList = res.data.subSchoolInfo || [];
          let data = res.data.areaMapInfos || [];
          this.cityArr = data.map((item) => {
            item.name = item.regionName;
            item.value = item.noCheckNum; //未处理隐患数
            return item;
          });

          this.searchParams = {
            eduId: req.eduId,
            regionCode: req.regionCode,
            eduBuresuType: req.eduBuresuType,
            type: "",
            schoolId: ""
          };
        }
      } else if (res.code == 101) {
      } else {
      }
    },
    async getAreaSchoolList() {
      let req = { eduId: this.eduInfo.eduId };
      let res = await this.$Http.getTowCenterStatistics(req);
      if (res.code == 200) {
        let data = res.data || [];
        data.map((item) => {
          item.isUnfold = false;
          return item;
        });
        this.areaSchoolList = data;
      } else if (res.code == 101) {
        this.areaSchoolList = [];
      } else {
        this.areaSchoolList = [];
      }
    },
    checkHiddenDanger(num, type) {
      if (num > 0) {
        // console.log(type)
        this.searchParams.type = type;
        this.showCount++;
      }
    },
    // 点击直属学校
    clickRow(row) {
      this.msg = row.schoolName;
      this.getEduSchoolHiddenDangerStatistics(row.schoolId);
      this.searchParams = {
        eduId: "",
        regionCode: "",
        eduBuresuType: "",
        type: "",
        schoolId: row.schoolId
      };
    },
    // 点击直属学校查询学校信息
    async getEduSchoolHiddenDangerStatistics(schoolId) {
      let req = {
        schoolId: schoolId
      };
      let res = await this.$Http.getEduSchoolHiddenDangerStatistics(req);
      if (res.code == 200) {
        if (res.data) {
          this.resData = res.data;
          // this.getRislNum(this.resData.riskTotal || [])
        }
      } else if (res.code == 101) {
      } else {
      }
    }
  },
  destroyed() {}
};
</script>

<style lang="scss" scoped>
.content {
  display: flex;
  padding: 0 3.8%;
  justify-content: space-between;
  .left {
    width: 460px;
    margin-top: 40px;
    .left-top {
      margin-bottom: 10px;
      width: 460px;
      height: 268px;
      background: url("~@/assets/img/eduBigHidden2/left-top-bg.png") center
        center no-repeat;
      background-size: 100% 100%;
    }
    .left-top-title {
      font-size: 16px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #6ff3fa;
      padding: 16px 0 0 16px;
    }
    .triple {
      width: 460px;
      height: 230px;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .scale {
      margin-right: 90px;
      width: 103px;
      height: 103px;
      border-radius: 50%;
      background: rgba(0, 26, 79, 0);
      border: 2px solid #2bd4d6;
      border-radius: 50%;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      .num {
        font-size: 19px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #67e2e9;
      }
      .name {
        font-size: 12px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #cecece;
      }
    }
    .triple-list {
      // width: 206px;
      text-align: center;
      .triple-first {
        .triple-num {
          color: #c23c33;
          font-size: 14px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
        }
        .triple-name {
          color: #cecece;
          font-size: 14px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
        }
      }
      .triple-second {
        margin-top: 10px;
        .triple-num {
          color: #eca800;
          font-size: 14px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
        }
        .triple-name {
          color: #cecece;
          font-size: 14px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
        }
      }
      .triple-third {
        margin-top: 10px;
        .triple-num {
          color: #51a6fe;
          font-size: 14px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
        }
        .triple-name {
          color: #cecece;
          font-size: 14px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
        }
      }
    }
    .left-center {
      position: relative;
      top: 6px;
      .left-center-title {
        font-size: 16px;
        font-family: PingFang SC;
        font-weight: 400;
        color: #6ff3fa;
        padding: 12px 0 0 16px;
      }
      margin-bottom: 10px;
      width: 100%;
      height: 250px;
      background: url("~@/assets/img/eduBigHidden2/left-center-bg.png") center
        center no-repeat;
      background-size: 100% 100%;
    }
    .left-bottom {
      position: relative;
      top: 10px;
      .left-bottom-title {
        font-size: 16px;
        font-family: PingFang SC;
        font-weight: 400;
        color: #6ff3fa;
        padding: 12px 0 0 16px;
      }
      margin-bottom: 10px;
      width: 100%;
      height: 250px;
      background: url("~@/assets/img/eduBigHidden2/left-bottom-bg.png") center
        center no-repeat;
      background-size: 100% 100%;
    }
  }
  .center {
    width: 800px;
    background: url("~@/assets/img/eduBigHidden2/center-bg.png") center center
      no-repeat;
    background-size: 100% 100%;
  }
  .right {
    margin-top: 12px;
    width: 25%;
    .school-list {
      padding: 29px 0px 0px 20px;
      width: 100%;
      height: 100%;
      background: url("~@/assets/img/eduBigData/school_list.png") center center
        no-repeat;
      background-size: 100% 100%;
      margin-top: -12px;
      .rate-content {
        margin-top: 15px;
        width: 100%;
        height: 720px;
        overflow: scroll;
      }
      .rate-list {
        display: flex;
        justify-content: space-between;
        align-items: center;
        height: 38px;
        text-align: center;
        background: rgba(17, 165, 215, 0.2);
        border-radius: 4px;
        margin-bottom: 8px;
        cursor: pointer;
        &:nth-child(2n) {
          background: rgba(17, 165, 215, 0.05);
        }
        .rate-name {
          flex: 0 0 100%;
          font-size: 16px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #c4cdff;
          line-height: 22px;
          text-align: center;
        }
        &:nth-child(1) {
          .rate-score {
            font-size: 16px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #c4cdff;
            line-height: 22px;
            background: linear-gradient(180deg, #edefff 0%, #fff04d 100%);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
          }
        }
        &:nth-child(2) {
          .rate-score {
            font-size: 16px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #c4cdff;
            line-height: 22px;
            background: linear-gradient(180deg, #edefff 0%, #4d76ff 100%);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
          }
        }
        &:nth-child(3) {
          .rate-score {
            font-size: 16px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #c4cdff;
            line-height: 22px;
            background: linear-gradient(180deg, #ffffff 0%, #8e6236 100%);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
          }
        }
      }
      .rate-list-pitch-on {
        display: flex;
        justify-content: space-between;
        align-items: center;
        height: 38px;
        text-align: center;
        background-image: linear-gradient(
          to left,
          rgba(39, 209, 237, 0),
          rgba(28, 188, 227, 1),
          rgba(17, 165, 215, 0)
        );
        border-radius: 4px;
        margin-bottom: 8px;
        .rate-name {
          flex: 0 0 100%;
          font-size: 16px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #ffff00;
          line-height: 22px;
          text-align: center;
        }
      }
      //   直属学校条数信息
      .total-content {
        width: 100%;
        display: flex;
        text-align: center;
        flex-direction: column;
        img {
          margin-left: 37.5%;
          width: 25%;
          opacity: 0.8;
        }
        span {
          margin-left: 35%;
          width: 30%;
          color: rgba(233, 237, 255, 0.8);
        }
      }
    }
  }
}
.map {
  width: 100%;
  height: 500px;
}
</style>
